import Select, { Props } from "react-select";
import { SelectOption, DropdownProps } from "./model";

export const Dropdown = <
  ValueType = any,
  IdType = string,
  IsMultiType extends boolean = false,
  AdditionalKeys extends {} = {}
>({
  options,
  value,
  roundedRectangle,
  small,
  defaultMenuIsOpen,
  isMulti,
  isDisabled,
  placeholder,
  extraClassNames,
  isSearchable = false,
  isClearable = false,
  inPortal,
  onChange,
  onMenuOpen,
  onMenuClose,
  formatOptionLabel,
  closeMenuOnSelect = true,
}: DropdownProps<ValueType, IdType, IsMultiType, AdditionalKeys>) => {
  const classNames = `CustomSelect ${roundedRectangle ? "RoundedRect" : ""} ${
    small ? "Small" : ""
  } ${extraClassNames ? extraClassNames : ""}`;

  const onChangeWrapper: Props<
    SelectOption<ValueType, IdType> & AdditionalKeys,
    IsMultiType
  >["onChange"] = (newValue, actionMeta) => {
    if (isDisabled) {
      console.warn("Dropdown disabled");
      return;
    }
    if (newValue !== null) {
      onChange(newValue, actionMeta);
    } else if (newValue === null && isClearable) {
      // Not sure this is the best way to implement
      // Ideally we don't want to assert any type
      onChange(newValue as any, actionMeta);
    } else {
      console.warn("No option found.");
    }
  };

  return (
    <Select<SelectOption<ValueType, IdType>, IsMultiType>
      className={classNames}
      isDisabled={isDisabled}
      isMulti={isMulti}
      placeholder={placeholder}
      defaultMenuIsOpen={defaultMenuIsOpen}
      onMenuOpen={onMenuOpen}
      onMenuClose={onMenuClose}
      classNamePrefix="CustomSelect"
      isClearable={isClearable}
      options={options}
      formatOptionLabel={formatOptionLabel}
      value={value ? value : null}
      menuPortalTarget={
        typeof inPortal === "string"
          ? document.getElementById(inPortal)
          : inPortal
          ? document.getElementById("dropdown_portal")
          : undefined
      }
      isSearchable={isSearchable}
      onChange={
        onChangeWrapper as Props<
          SelectOption<ValueType, IdType>,
          IsMultiType
        >["onChange"]
      }
      menuPlacement="auto"
      closeMenuOnSelect={closeMenuOnSelect}
    />
  );
};
